import { useCallback, useEffect, useState } from "react";

export const useScrollbarWidth = () => {
  const calculateScrollbarWidth = useCallback(() => {
    // Создаем временный контейнер
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll"; // Принудительно показываем скроллбар
    outer.style.width = "100px";
    outer.style.position = "absolute";
    outer.style.top = "-9999px";

    document.body.appendChild(outer);

    // Создаем внутренний элемент
    const inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    // Вычисляем разницу в ширине
    const currentScrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Удаляем временные элементы
    outer.parentNode?.removeChild(outer);

    return currentScrollbarWidth ?? 0;
  }, []);

  const recalculateScrollbarWidth = useCallback(() => {
    const width = calculateScrollbarWidth();
    setScrollbarWidth(width);
  }, [calculateScrollbarWidth]);

  const [scrollbarWidth, setScrollbarWidth] = useState(() =>
    calculateScrollbarWidth(),
  );

  useEffect(() => {
    // Небольшая задержка для гарантии, что DOM готов
    const timer = setTimeout(() => {
      recalculateScrollbarWidth();
    }, 0);

    return () => clearTimeout(timer);
  }, [recalculateScrollbarWidth]);

  return { scrollbarWidth, recalculateScrollbarWidth };
};
